import { Box, Heading, Wrap, WrapItem } from "@chakra-ui/react";
import OfferingBgImage from "public/openStack/background.png";
import PageLayout from "@/layouts/pageLayout";
import { AdvantageCard } from "@/components/advantageCard";
import { OFFERINGS_CONSTANTS } from "./constants";

const OfferingsComponent = () => {
  return (
    <Box bgImage={`url(${OfferingBgImage.src})`} bgSize="cover">
      <PageLayout>
        <Heading as="h2" fontWeight={"400"} textAlign={"center"} fontSize={"40px"}>
          {OFFERINGS_CONSTANTS.title}
        </Heading>
        <Wrap gap={{ base: 8, md: 12 }} justify={"center"} pb={16}>
          {OFFERINGS_CONSTANTS.list.map((item, index) => (
            <WrapItem
              key={index}
              w={{
                base: "100%",
                sm: "280px",
                md: "360px",
                lg: "300px",
                xl: "370px",
                "2xl": "480px",
              }}
              alignItems={"stretch"}
            >
              <AdvantageCard key={index} {...item} bgColor="white" getHoverEffect />
            </WrapItem>
          ))}
        </Wrap>
      </PageLayout>
    </Box>
  );
};

export default OfferingsComponent;
